<div class="my-modal__close" (click)="modal.dismiss('Cross click')">
  <i class="fa-solid fa-times"></i>
</div>
<div class="my-modal__body" style="overflow: hidden">
  <h2 class="title">Edit Category</h2>
  <div class="form-group" *ngIf="isSubregionCombination">
    <label for="">Category Edit Mode</label>
    <select class="form-control" [(ngModel)]="categoryEditMode" (change)="categoryEditModeChange($event)">
      <option *ngFor="let sub of bottomSubregions" [value]="sub.slug">{{ sub.name }}</option>
    </select>
  </div>
  <!-- Event Image -->
  <!-- <h2>Event Image</h2> -->
  <img loading="lazy" *ngIf="imageBase64 && !isSubregionCombination"
    class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64" alt="" />
  <img loading="lazy" *ngIf="subCategory?.image && !isSubregionCombination"
    class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.image" />

  <button class="com_btn px-1 month-list-add-more mt-0" (click)="upload.click()" *ngIf="!isSubregionCombination"><i
      class="fas fa-plus"></i> Upload Event Image</button>
  <input type="file" #upload (change)="saveProductCharSelectedImage($event)" class="suggestion-modal-pic-input d-none"
    accept="image/*" />
  <!-- End Event Image -->

  <!-- Banner Image -->
  <h6 class="mb-1">Banner Image</h6>
  <img loading="lazy" *ngIf="imageBase64Banner && !isSubregionCombination"
    class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64Banner" alt="" />
  <img loading="lazy" *ngIf="subCategory?.bannerImage && !isSubregionCombination"
    class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.bannerImage" />

  <button class="com_btn px-1 month-list-add-more mt-0" (click)="uploadBanner.click()"
    *ngIf="!isSubregionCombination"><i class="fas fa-plus"></i> Upload Banner Image</button>
  <input type="file" #uploadBanner (change)="saveProductCharSelectedImage($event, true)"
    class="suggestion-modal-pic-input d-none" accept="image/*" />
  <!-- End Banner Image -->

  <!-- Promo Banner Image -->
  <h6 class="mb-1">Promo Banner Image</h6>
  <img loading="lazy" *ngIf="encodedPromoFile && !isSubregionCombination"
    class="map-search-listing-img mt-2 product-char-image w-100" [src]="encodedPromoFile" alt="" />
  <img loading="lazy" *ngIf="subCategory?.promoBannerImage && !isSubregionCombination"
    class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.promoBannerImage" />

  <button class="com_btn px-1 month-list-add-more mt-0" (click)="uploadPromoImage.click()"
    *ngIf="!isSubregionCombination"><i class="fas fa-plus"></i> Upload Promo Image</button>
  <input type="file" #uploadPromoImage style="visibility: hidden" id="upload-promo-image"
    (change)="promoBannerChange($event)" class="suggestion-modal-pic-input d-none" accept="image/*" />

  <!-- End Promo Banner Image -->

  <div class="row" *ngIf="!isSubregionCombination">
    <div class="form-group col-12">
      <h6 class="mb-1">Redirect URL</h6>
      <input type="text" placeholder="Redirect URL" [(ngModel)]="promoRedirectURL" class="form-control" />
    </div>
  </div>

  <div class="row" *ngIf="isSubregionCombination">
    <div class="col-6">
      <button class="com_btn px-1 month-list-add-more mt-0 w-100" (click)="paginateRegion(false)"><i
          class="fas fa-chevron-left"></i> Previous Sub Region</button>
    </div>
    <div class="col-6">
      <button class="com_btn px-1 month-list-add-more mt-0 w-100" (click)="paginateRegion(true)">Next Sub Region <i
          class="fas fa-chevron-right"></i></button>
    </div>
  </div>

  <ul class="nav nav-tabs mt-3">
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{ active: formMenu == 'main' }" (click)="formMenu = 'main'">Main</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{ active: formMenu == 'meta' }" (click)="formMenu = 'meta'">Meta</a>
    </li>
    <li class="nav-item" *ngIf="!isSubregionCombination">
      <a class="nav-link" [ngClass]="{ active: formMenu == 'faq' }" (click)="formMenu = 'faq'">FAQ</a>
    </li>
    <li class="nav-item" *ngIf="!isSubregionCombination">
      <a class="nav-link" [ngClass]="{ active: formMenu == 'types' }" (click)="formMenu = 'types'">Types</a>
    </li>
    
  </ul>

  <ng-container *ngIf="formMenu == 'main'">
    <div class="row" *ngIf="!isSubregionCombination">
      <div class="form-group col-12">
        <h6 class="my-1">Category Name</h6>
        <input type="text" [(ngModel)]="categoryName" class="form-control" placeholder="Enter Category Name" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-12">
        <h6 class="mb-1">Bottom Text</h6>
        <textarea id="bottomText" [(ngModel)]="currentBottomText" rows="5" class="form-control"
          placeholder="Enter Bottom Text(HTML)"></textarea>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="formMenu == 'meta'">
    <div class="row">
      <div class="form-group col-12">
        <h6 class="mb-1">Meta Config</h6>
        <textarea readonly [(ngModel)]="domMeta" cols="30" rows="10" class="form-control" style="min-height: 300px"
          placeholder="Enter Meta Config"></textarea>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="formMenu == 'meta'">
    <div class="row">
      <div class="form-group col-12">
        <h6 class="mb-1">Schema Code</h6>
        <textarea readonly [(ngModel)]="domSchema" cols="30" rows="10" class="form-control" style="min-height: 300px"
          placeholder="Enter Schema Code"></textarea>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="formMenu == 'faq'">
    <app-edit-category-faq [filter]="filter" [filterId]="filterId"></app-edit-category-faq>

  </ng-container>

  <ng-container *ngIf="formMenu == 'types'">
    Category Id: {{categoryId}}
    <app-edit-types [categoryId]="categoryId"></app-edit-types>
  </ng-container>


  <duv class="d-flex justify-content-end">
    <button type="button" class="btn btn-secondary" (click)="editCategorySubmit()">Save</button>
  </duv>
</div>